import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-65fd26ba"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-address"
};
const _hoisted_2 = {
  class: "user-address-tit"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/after_sale/after_sale_local.png"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", {
  class: "tit"
}, "收货地址", -1));
const _hoisted_5 = {
  class: "user-address-item user-address-item-top"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "收货人", -1));
const _hoisted_7 = {
  class: "user-address-item"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "收货地址", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("span", {
    class: "copy-icon",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.CopyContent($event), ["stop"]))
  }, "复制")]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", null, _toDisplayString($props.user_address.receive_name) + " " + _toDisplayString($props.user_address.receive_phone), 1)]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, _toDisplayString($props.user_address.receive_address), 1)])]);
}